import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getRoleTitle = (record, translate) =>
  `${translate("resources.user.fields.role")} ${record.id} (${record.name})`;

const Edit = (props) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={true}
      title={<DynamicTitleWithTooltip getTitle={getRoleTitle} />}
    >
      <Form />
    </RaEdit>
  );
};
export default Edit;
